/* eslint-disable import/no-unresolved */
import * as React from 'react';
import {
  ThemePalette,
} from 'theme/types';
// tslint:disable:max-line-length
export const deglawySVG: JSX.Element = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.27044 10.1947C4.33309 10.1947 2.98092 8.65193 2.98092 6.44543C2.98092 4.24189 4.36363 2.64307 6.27044 2.64307C8.16115 2.64307 9.5322 4.24189 9.5322 6.44543C9.5322 8.61948 8.16115 10.1947 6.27044 10.1947ZM9.39064 11.3097L8.73273 10.9528L9.40174 10.6195C11.3979 9.63127 11.5531 7.17404 11.5531 6.44543C11.5531 5.07965 11.2061 4.02065 10.4624 3.10619L10.2678 2.87021L10.4486 2.62242L11.4754 1.20649L10.0041 0L9.11304 1.22124L8.90484 1.50737L8.62447 1.30088C7.87496 0.752212 6.97277 0.684366 6.27045 0.684366C3.14471 0.684366 0.960022 3.0531 0.960022 6.44543C0.960022 10.0236 2.94512 12.1593 6.27045 12.1593C7.80834 12.1593 9.46281 13.0413 9.46281 14.9764C9.46281 16.764 8.18059 17.9646 6.27045 17.9646C4.53852 17.9646 3.20023 16.8702 3.00591 15.3599H0.974179C1.15434 18.1121 3.28073 20 6.27045 20C9.40174 20 11.5087 17.9794 11.5087 14.9764C11.5087 12.7434 10.3761 11.8437 9.39064 11.3097Z"
      fill={ThemePalette.SECONDARY_COLOR}
    />
  </svg>
);

export default deglawySVG;
